module.exports = __webpack_public_path__ + "static/img/verifaction.ae77d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verifaction.png
// module id = EHBt
// module chunks = 1